export default __webpack_public_path__ + "static/media/Adult_img.fee454b1.svg";